import Quasar from 'quasar/src/vue-plugin.js';
import { LanguageEnum } from "@/enums"
import { AuthStore } from '@/stores/authentication'

export function useSetLangQuasar(authStore: AuthStore|null, lang: string|LanguageEnum |null = null ) {
    let langDynamic = lang;
    if (!langDynamic) {
        langDynamic = (authStore?.lang as string|undefined ?? 'fr')
    }

    import(`quasar/lang/${langDynamic}.js`).then(lang => {
        Quasar.lang.set(lang.default);
    })
}